import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import Search from "../components/neighborhoodSearch/search";
import SavedSearch from "../components/neighborhoodSearch/savedSearch";

const NeighborhoodSearchPage = () => {
  return (
    <>
      <Routes>
        <Route path="search" element={<Navigate to="/ns/search/start" replace />} />
        <Route path="search/:tab?" element={<Search />} />
        <Route path="searches" element={<Navigate to="/ns/searches/list" replace />} />
        <Route path="searches/:tab" element={<SavedSearch />} />
      </Routes>
      <Outlet />
    </>
  );
};

export default NeighborhoodSearchPage;
